// A missing price is never a free item, including values imported by OCR.
export function isExplicitZeroPrice(value) {
  if (typeof value === "number") return Number.isFinite(value) && value === 0;
  if (typeof value !== "string" || !value.trim()) return false;
  const normalized = value.trim().replace(",", ".");
  return /^[+-]?(?:0+(?:\.0*)?|\.0+)(?:e[+-]?\d+)?$/i.test(normalized) && Number(normalized) === 0;
}

const numericPrice = (value) => {
  if ((typeof value !== "string" && typeof value !== "number") || String(value).trim() === "") return NaN;
  return Number(String(value).trim().replace(",", "."));
};

export function isDeliveryNotePriceValidForVerification(line, priceKey = "unit_price_in_dn") {
  const price = numericPrice(line[priceKey]);
  if (!Number.isFinite(price) || price < 0) return false;
  if (price > 0) return !line.is_free_stock && line.price_status !== "missing";
  return line.price_status !== "estimated" && (Boolean(line.is_free_stock) || line.price_status === "missing");
}

/** Clear the exception before legacy normalizers can force a newly entered price back to zero. */
export function updateComplimentaryLine(line, field, value, {
  priceKey = "unit_price_in_dn", identityFields = ["item_id", "quantity_in_dn", "unit_level"],
} = {}) {
  const updated = { ...line, [field]: value };
  const changedIdentity = identityFields.includes(field) && String(line[field] ?? "") !== String(value ?? "");
  if (line.price_estimate_source && ((field === priceKey && numericPrice(line[priceKey]) !== numericPrice(value))
    || (changedIdentity && !["quantity", "quantity_in_dn", "qty"].includes(field)))) {
    updated.price_estimate_source = "manual";
  }
  if ((field === priceKey && !isExplicitZeroPrice(value)) || changedIdentity) {
    updated.is_free_stock = false;
    if (field === priceKey && !isExplicitZeroPrice(value)) updated.free_stock_reason = "";
  }
  if (field === "price_status") {
    updated.is_free_stock = false;
    updated.free_stock_reason = "";
  }
  return normalizeComplimentaryPrice(updated, priceKey);
}

export function normalizeComplimentaryPrice(line, priceKey = "unit_price_in_dn") {
  const clearEstimateSource = line.price_estimate_source ? { price_estimate_source: null } : {};
  if (line.is_free_stock && isExplicitZeroPrice(line[priceKey])) return { ...line, ...clearEstimateSource, price_status: "confirmed" };
  // Preserve an explicit Estimate choice while the user is still entering the amount.
  const priceStatus = line.price_status === "estimated" ? "estimated"
    : numericPrice(line[priceKey]) > 0 ? "confirmed" : "missing";
  return { ...line, ...(priceStatus !== "estimated" ? clearEstimateSource : {}), price_status: priceStatus, is_free_stock: false,
    free_stock_reason: isExplicitZeroPrice(line[priceKey]) ? line.free_stock_reason || "" : "" };
}
